var exports = {
  "O": "xcc377c0b--8d3374--offers",
};

module.exports = exports;
